import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { createTheme as createMdTheme } from '@mui/material/styles';
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/material/utils';
import useLazyCSS from 'docs/src/modules/utils/useLazyCSS';
import { getMetaThemeColor } from '@mui/docs/branding';
import useMediaQuery from '@mui/material/useMediaQuery';
import useLocalStorageState from '@mui/utils/useLocalStorageState';
import { jsx as _jsx } from "react/jsx-runtime";
var themeInitialOptions = {
  dense: false,
  direction: 'ltr',
  paletteMode: 'light'
};
export var highDensity = {
  components: {
    MuiButton: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiFilledInput: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiFormControl: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiInputBase: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiInputLabel: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiListItem: {
      defaultProps: {
        dense: true
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiFab: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiTable: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiTextField: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiToolbar: {
      defaultProps: {
        variant: 'dense'
      }
    }
  }
};
export var DispatchContext = /*#__PURE__*/React.createContext(function () {
  throw new Error('Forgot to wrap component in `ThemeProvider`');
});
if (false) DispatchContext.displayName = "DispatchContext";
if (false) {
  DispatchContext.displayName = 'ThemeDispatchContext';
}
export var ThemeOptionsContext = /*#__PURE__*/React.createContext(themeInitialOptions);
if (false) ThemeOptionsContext.displayName = "ThemeOptionsContext";
if (false) {
  ThemeOptionsContext.displayName = 'ThemeOptionsContext';
}
export function ThemeProvider(props) {
  var children = props.children;
  var _React$useReducer = React.useReducer(function (state, action) {
      switch (action.type) {
        case 'SET_DENSE':
          return _extends({}, state, {
            dense: action.payload
          });
        case 'RESET_DENSITY':
          return _extends({}, state, {
            dense: themeInitialOptions.dense
          });
        case 'CHANGE':
          // No value changed
          if ((!action.payload.paletteMode || action.payload.paletteMode === state.paletteMode) && (!action.payload.direction || action.payload.direction === state.direction)) {
            return state;
          }
          return _extends({}, state, {
            paletteMode: action.payload.paletteMode || state.paletteMode,
            direction: action.payload.direction || state.direction
          });
        default:
          throw new Error("Unrecognized type ".concat(action.type));
      }
    }, themeInitialOptions),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    themeOptions = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  var direction = themeOptions.direction,
    paletteMode = themeOptions.paletteMode;
  useLazyCSS('/static/styles/prism-okaidia.css', '#prismjs');

  // TODO replace with useColorScheme once all pages support css vars
  var _useColorSchemeShim = useColorSchemeShim(),
    mode = _useColorSchemeShim.mode,
    systemMode = _useColorSchemeShim.systemMode;
  var calculatedMode = mode === 'system' ? systemMode : mode;
  useEnhancedEffect(function () {
    dispatch({
      type: 'CHANGE',
      payload: {
        paletteMode: calculatedMode
      }
    });
  }, [calculatedMode]);
  useEnhancedEffect(function () {
    document.body.setAttribute('dir', direction);
  }, [direction]);
  useEnhancedEffect(function () {
    // To support light and dark mode images in the docs
    if (paletteMode === 'dark') {
      document.body.classList.remove('mode-light');
      document.body.classList.add('mode-dark');
    } else {
      document.body.classList.remove('mode-dark');
      document.body.classList.add('mode-light');
    }
    var metas = document.querySelectorAll('meta[name="theme-color"]');
    metas.forEach(function (meta) {
      meta.setAttribute('content', getMetaThemeColor(paletteMode));
    });
  }, [paletteMode]);
  React.useEffect(function () {
    // Expose the theme as a global variable so people can play with it.
    window.createTheme = createMdTheme;
  }, []);
  return /*#__PURE__*/_jsx(ThemeOptionsContext.Provider, {
    value: themeOptions,
    children: /*#__PURE__*/_jsx(DispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
}
false ? void 0 : void 0;

/**
 * @returns {(nextOptions: Partial<typeof themeInitialOptions>) => void}
 */
export function useChangeTheme() {
  var dispatch = React.useContext(DispatchContext);
  return React.useCallback(function (options) {
    return dispatch({
      type: 'CHANGE',
      payload: options
    });
  }, [dispatch]);
}

// TODO: remove once all pages support css vars and replace call sites with useColorScheme()
export function useColorSchemeShim() {
  var _useLocalStorageState = useLocalStorageState('mui-mode', 'system'),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    mode = _useLocalStorageState2[0],
    setMode = _useLocalStorageState2[1];
  var prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)', {
    noSsr: true
  });
  var systemMode = prefersDarkMode ? 'dark' : 'light';
  return {
    mode: mode,
    systemMode: systemMode,
    setMode: setMode
  };
}